import React from "react";

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="border-b border-neutral-800 bg-[#0A0A0A] px-6 py-5 flex items-center justify-between flex-wrap gap-4" data-testid={testId || "page-header"}>
      <div>
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FF6600] mb-1">// MODUL</div>
        <h1 className="font-display font-black text-3xl text-white leading-none">{title}</h1>
        {subtitle && <p className="text-neutral-400 text-sm mt-2">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}

export function DataCard({ label, value, hint, accent, testId }) {
  return (
    <div className="border border-neutral-800 bg-[#141414] p-5" data-testid={testId}>
      <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500 mb-2">{label}</div>
      <div className={`font-display font-black text-3xl leading-none ${accent === "orange" ? "text-[#FF6600]" : accent === "yellow" ? "text-[#FFD700]" : accent === "green" ? "text-[#16A34A]" : accent === "red" ? "text-[#DC2626]" : "text-white"}`}>{value}</div>
      {hint && <div className="text-xs text-neutral-500 mt-2">{hint}</div>}
    </div>
  );
}

export function Empty({ message = "Belum ada data" }) {
  return (
    <div className="border border-dashed border-neutral-800 bg-neutral-900/40 p-10 text-center text-sm text-neutral-500">
      {message}
    </div>
  );
}
